import type { CatalogApp, ReleaseSummary } from "@cheesy/contracts";

export const demoApps: CatalogApp[] = [
  {
    id: "pit-scout",
    mobileSupported: true,
    slug: "pit-scout",
    name: "Pit Scout",
    summary: "Capture fast, consistent robot observations from the pit.",
    description: "A focused scouting workspace for collecting mechanisms, dimensions, photos, and match-readiness notes before qualification rounds begin.",
    status: "approved",
    categories: ["Scouting", "Competition"],
    tags: ["field", "data", "collaboration"],
    owners: ["Maya Chen", "Eli Brooks"],
    permissions: { camera: true, microphone: false, geolocation: false, clipboardRead: false, clipboardWrite: true, popups: false, fullscreen: true, userDirectory: false },
    updatedAt: Date.now() - 86_400_000,
    liveVersion: "9c8d2a1",
    repository: "team254/pit-scout",
  },
  {
    id: "strategy-board",
    mobileSupported: false,
    slug: "strategy-board",
    name: "Strategy Board",
    summary: "Turn match data into a clear alliance game plan.",
    description: "An interactive match-planning canvas that combines scouting signals, role assignments, and drive-team notes in one shared view.",
    status: "approved",
    categories: ["Strategy", "Competition"],
    tags: ["matches", "planning", "analytics"],
    owners: ["Noah Kim"],
    permissions: { camera: false, microphone: false, geolocation: false, clipboardRead: false, clipboardWrite: true, popups: true, fullscreen: true, userDirectory: false },
    updatedAt: Date.now() - 3 * 86_400_000,
    liveVersion: "4a6f309",
    repository: "team254/strategy-board",
  },
  {
    id: "inventory",
    mobileSupported: false,
    slug: "inventory",
    name: "Parts Inventory",
    summary: "Know what is on the shelf before the next hardware run.",
    description: "Track parts, locations, low-stock thresholds, and restock requests across the lab.",
    status: "approved",
    categories: ["Operations"],
    tags: ["parts", "lab", "inventory"],
    owners: ["Avery Singh"],
    permissions: { camera: true, microphone: false, geolocation: false, clipboardRead: false, clipboardWrite: false, popups: false, fullscreen: false, userDirectory: false },
    updatedAt: Date.now() - 8 * 86_400_000,
    liveVersion: "e170c4b",
    repository: "team254/inventory",
  },
  {
    id: "travel-planner",
    mobileSupported: false,
    slug: "travel-planner",
    name: "Travel Planner",
    summary: "Coordinate competition travel without spreadsheet sprawl.",
    description: "A private hub for itineraries, room assignments, packing lists, and transportation status.",
    status: "pending_approval",
    categories: ["Operations"],
    tags: ["travel", "planning"],
    owners: ["Demo Admin"],
    permissions: { camera: false, microphone: false, geolocation: true, clipboardRead: false, clipboardWrite: false, popups: false, fullscreen: true, userDirectory: false },
    updatedAt: Date.now() - 3_600_000,
    repository: "team254/travel-planner",
  },
];

export const demoReleases: ReleaseSummary[] = [
  { id: "r3", appId: "pit-scout", commitSha: "a9dc4b7f18f43", imageDigest: "sha256:8f1d…93b2", status: "ready", createdAt: Date.now() - 35 * 60_000, scan: { critical: 0, high: 2, secrets: 0 } },
  { id: "r2", appId: "pit-scout", commitSha: "9c8d2a1b3021f", imageDigest: "sha256:4d9e…02ca", status: "promoted", createdAt: Date.now() - 86_400_000, promotedAt: Date.now() - 82_800_000, scan: { critical: 0, high: 1, secrets: 0 } },
  { id: "r1", appId: "pit-scout", commitSha: "026a4b9f7e25d", imageDigest: "sha256:993c…70fd", status: "rolled_back", createdAt: Date.now() - 6 * 86_400_000, promotedAt: Date.now() - 5 * 86_400_000, scan: { critical: 0, high: 0, secrets: 0 } },
];

export const demoNotifications = [
  { id: "n1", title: "Candidate ready to preview", body: "Pit Scout build a9dc4b7 passed its health and security checks.", createdAt: Date.now() - 35 * 60_000, read: false },
  { id: "n2", title: "Approval requested", body: "Travel Planner is ready for administrative confirmation.", createdAt: Date.now() - 3_600_000, read: false },
  { id: "n3", title: "Release promoted", body: "Strategy Board 4a6f309 is now live.", createdAt: Date.now() - 3 * 86_400_000, read: true },
];
